"use client";

import React from "react";

import { IconButton } from "@/components/flowbite/icon-button/icon-button";
import { cn } from "@/shared/helpers/cn.helper";

import { MinusIcon, PlusIcon } from "../icons-lib";

interface ZoomControlsProps {
  zoomPercentage?: number | null;
  onZoomIn?: () => void;
  onZoomOut?: () => void;
  className?: string;
}

export const ZoomControls: React.FC<ZoomControlsProps> = ({
  zoomPercentage,
  onZoomIn,
  onZoomOut,
  className,
}) => {

  return (
    <div
      className={cn(
        "rounded-lg bg-white shadow-md",
        "flex flex-col items-center gap-2 p-2.5",
        className,
      )}
    >
      <IconButton
        icon={PlusIcon}
        type="button"
        variant="primary"
        onClick={onZoomIn}
      />
      {zoomPercentage !== null && (
        <span className="text-xs font-medium text-gray-700">
          {zoomPercentage}%
        </span>
      )}
      <IconButton
        icon={MinusIcon}
        type="button"
        variant="primary"
        onClick={onZoomOut}
      />
    </div>
  );
};

